export default __webpack_public_path__ + "static/media/nuleepLogo.f5b56cc6.png";